import { Injectable, Injector, Inject } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sotrageKeys } from './storageKeys';
import { MmI18nConfig } from './i18n-config';
import { MM_I18N_CONFIG_TOKEN } from './i18n-config-token';

@Injectable()
export class I18nInterceptor implements HttpInterceptor {
    constructor(@Inject(MM_I18N_CONFIG_TOKEN) private config: MmI18nConfig) {

    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     
        var language = localStorage.getItem(sotrageKeys.lang) || this.config.defaultLang;
        const headers = req.headers
            .set('Current-Language', language)
            .set('Accept-Language', 'zh-CN,zh;q=0.8');
        const newReq = req.clone({ headers });
        return next.handle(newReq);
    }
}
